import ForecastProvider from "../provider/ForecastProvider";
import ForecastV2Provider from "../provider/ForecastV2Provider";
import {
  SET_DATA_FORECAST,
  SET_URL_EXPORT,
  SET_LOADING_APPLY_FORECAST,
  SET_DATA_FE_FORECAST,
  SET_DATA_LAST_TRIMESTER,
  SET_DATA_CONSENSUS_REPORT,
  SET_DATA_CONSENSUS_REPORT_ENDOGENIZE,
  SET_FORECAST_STATUS,
  SET_FORECAST_ERROR,
  SET_FORECAST_LOAD_STARTED,
  SET_FORECAST_V2,
  SET_FORECAST_V2_STATUS,
  SET_DIAGNOSTICS,
  SET_DIAGNOSTICS_STATUS,
} from "./ForecastMutationTypes";
import apolloClient from "@/apollo";

function describeError(error) {
  if (!error) return { message: "Unknown error", detail: "" };
  const gql = error.graphQLErrors && error.graphQLErrors.length ? error.graphQLErrors.map((e) => e.message).join("; ") : "";
  const net = error.networkError ? String(error.networkError.message || error.networkError) : "";
  const message = gql || net || error.message || String(error);
  return { message, detail: error.stack ? String(error.stack).split("\n").slice(0, 3).join("\n") : "" };
}

export default {
  state: {
    resultForeCast: [],
    urlExport: "",
    loadingApplyForecast: false,
    fe_forecast: "[]",
    last_trimester: "[]",
    consensus_report_result: "[]",
    consensus_report_result_endogenize: "[]",
    // upgrade: explicit request lifecycle + v2 evidence blocks
    status: "idle", // idle | loading | success | error
    error: null, // {message, detail}
    loadStartedAt: null,
    v2: null, // ForecastV2Document or {available:false, reason}
    v2Status: "idle",
    diagnostics: null, // ForecastDiagnosticsDocument or {available:false, reason}
    diagnosticsStatus: "idle",
    diagnosticsCountry: null,
  },
  getters: {
    getForescartResult(state) {
      return state.resultForeCast;
    },
    getUrlExport(state) {
      return state.urlExport;
    },
    getLoadingApplyForecast(state) {
      return state.loadingApplyForecast;
    },
    getFeForecastm: (state) => {
      return state.fe_forecast;
    },
    getLastSemesterm: (state) => {
      return state.last_trimester;
    },
    getConsensusReportResult: (state) => {
      return state.consensus_report_result;
    },
    getConsensusReportResultEndogenize: (state) => {
      return state.consensus_report_result_endogenize;
    },
    getForecastStatus: (state) => state.status,
    getForecastError: (state) => state.error,
    getForecastLoadStartedAt: (state) => state.loadStartedAt,
    getForecastV2: (state) => state.v2,
    getForecastV2Status: (state) => state.v2Status,
    getForecastDiagnostics: (state) => state.diagnostics,
    getDiagnosticsStatus: (state) => state.diagnosticsStatus,
  },
  actions: {
    appleyForecast({ commit, dispatch }, payload) {
      commit(SET_LOADING_APPLY_FORECAST, true);
      commit(SET_FORECAST_STATUS, "loading");
      commit(SET_FORECAST_ERROR, null);
      commit(SET_FORECAST_LOAD_STARTED, Date.now());
      apolloClient.cache.reset();
      commit(SET_DATA_FORECAST, []);
      // the evidence blocks are scenario-dependent: fetch them alongside the forecast
      dispatch("loadForecastV2", payload);
      return ForecastProvider.ApplyForecast(payload)
        .then((data) => {
          commit(SET_DATA_FORECAST, data.data.forecastTool.data.replaceAll("\\", ""));
          commit(SET_FORECAST_STATUS, "success");
          commit(SET_LOADING_APPLY_FORECAST, false);
        })
        .catch((error) => {
          console.error("[forecastTool]", error);
          commit(SET_FORECAST_ERROR, describeError(error));
          commit(SET_FORECAST_STATUS, "error");
          commit(SET_LOADING_APPLY_FORECAST, false);
        });
    },
    async loadForecastV2({ commit }, payload) {
      commit(SET_FORECAST_V2_STATUS, "loading");
      const r = await ForecastV2Provider.getForecastV2(payload);
      commit(SET_FORECAST_V2, r.available ? r.doc : r);
      commit(SET_FORECAST_V2_STATUS, r.available ? "success" : "unavailable");
    },
    async loadDiagnostics({ commit, state }, country) {
      if (!country) return;
      if (state.diagnosticsCountry === country && state.diagnosticsStatus === "success") return;
      commit(SET_DIAGNOSTICS_STATUS, { status: "loading", country });
      const r = await ForecastV2Provider.getDiagnostics(country);
      commit(SET_DIAGNOSTICS, r.available ? r.doc : r);
      commit(SET_DIAGNOSTICS_STATUS, { status: r.available ? "success" : "unavailable", country });
    },
    exportExcel({ commit }, payload) {
      commit(SET_URL_EXPORT, "");
      return ForecastProvider.ApplyExportExcel(payload.headers, payload.data, payload.headers2, payload.data2)
        .then((data) => {
          commit(SET_URL_EXPORT, data.data.exportExcel.url);
          return data.data.exportExcel.url;
        })
        .catch((error) => {
          console.error("[exportExcel]", error);
          commit(SET_URL_EXPORT, "");
          throw error;
        });
    },

    setDataFeForecastM({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_FE_FORECAST, "[]");
      ForecastProvider.gerDataFeForecast(country).then((data) => {
        commit(SET_DATA_FE_FORECAST, data.data.teForecast.data.replaceAll("\\", ""));
      });
    },

    setDataLastSemesterM({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_LAST_TRIMESTER, "[]");
      ForecastProvider.getDataLastSemester(country).then((data) => {
        commit(SET_DATA_LAST_TRIMESTER, data.data.lastSemester.data.replaceAll("\\", ""));
      });
    },

    setDataConsensusReportResult({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_CONSENSUS_REPORT, "[]");
      ForecastProvider.getConsensusReport(country).then((data) => {
        commit(SET_DATA_CONSENSUS_REPORT, data.data.consensusResults.data.replaceAll("\\", ""));
      });
    },

    setDataConsensusReportResultEndogenize({ commit }, country) {
      apolloClient.cache.reset();
      commit(SET_DATA_CONSENSUS_REPORT_ENDOGENIZE, "[]");
      ForecastProvider.getConsensusReportEndogenize(country).then((data) => {
        commit(SET_DATA_CONSENSUS_REPORT_ENDOGENIZE, data.data.consensusResultsEndogenize.data.replaceAll("\\", ""));
      });
    },
    resetForecast({ commit }) {
      commit(SET_DATA_FORECAST, []);
      commit(SET_FORECAST_STATUS, "idle");
      commit(SET_FORECAST_ERROR, null);
      commit(SET_FORECAST_V2, null);
      commit(SET_FORECAST_V2_STATUS, "idle");
    },
  },
  mutations: {
    [SET_DATA_FORECAST](state, payload) {
      state.resultForeCast = payload;
    },
    [SET_URL_EXPORT](state, payload) {
      state.urlExport = payload;
    },
    [SET_LOADING_APPLY_FORECAST](state, payload) {
      state.loadingApplyForecast = payload;
    },
    [SET_DATA_FE_FORECAST](state, data) {
      state.fe_forecast = data;
    },
    [SET_DATA_LAST_TRIMESTER](state, data) {
      state.last_trimester = data;
    },
    [SET_DATA_CONSENSUS_REPORT](state, data) {
      state.consensus_report_result = data;
    },
    [SET_DATA_CONSENSUS_REPORT_ENDOGENIZE](state, data) {
      state.consensus_report_result_endogenize = data;
    },
    [SET_FORECAST_STATUS](state, s) {
      state.status = s;
    },
    [SET_FORECAST_ERROR](state, e) {
      state.error = e;
    },
    [SET_FORECAST_LOAD_STARTED](state, t) {
      state.loadStartedAt = t;
    },
    [SET_FORECAST_V2](state, doc) {
      state.v2 = doc;
    },
    [SET_FORECAST_V2_STATUS](state, s) {
      state.v2Status = s;
    },
    [SET_DIAGNOSTICS](state, doc) {
      state.diagnostics = doc;
    },
    [SET_DIAGNOSTICS_STATUS](state, { status, country }) {
      state.diagnosticsStatus = status;
      state.diagnosticsCountry = country;
    },
  },
};
